export const TOGGLE_BOXED_LAYOUT = 'TOGGLE_BOXED_LAYOUT';
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const TOGGLE_NAV_BEHIND = 'TOGGLE_NAV_BEHIND';
export const TOGGLE_FIXED_HEADER = 'TOGGLE_FIXED_HEADER';
export const CHANGE_SIDEBAR_WIDTH = 'CHANGE_SIDEBAR_WIDTH';
export const CHANGE_COLOR_OPTION = 'CHANGE_COLOR_OPTION';
export const CHANGE_THEME = 'CHANGE_THEME';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const userConstants = {
  LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USER_LOGIN_FAILURE',
  LOGOUT: 'USER_LOGOUT',
};
export const bannersConstants = {
  INFO_GET: 'BANNER_INFO_GET'
};

export const settingsActionsTypes = {
  SET_LOCALE: "SET_LOCALE",
  SET_AVAILABLE_LOCALES: "SET_AVAILABLE_LOCALES"
};

export const productsActionTypes = {
  SET_PRODUCTS_LIST: "SET_PRODUCT_LIST",
  SET_PRODUCT_TITLE: "SET_PRODUCT_TITLE",

  GET_PRODUCT_DATA_FOR_COPYING: "GET_PRODUCT_DATA_FOR_COPYING",

  REQUEST_IMAGE_ORDERING: "REQUEST_IMAGE_ORDERING",
  REQUEST_IMAGE_ORDERING_DONE: "REQUEST_IMAGE_ORDERING_DONE",
  REQUEST_IMAGE_ORDERING_ERROR: "REQUEST_IMAGE_ORDERING_ERROR",
  SAVE_IMAGES_ORDERING_REQUEST: "SAVE_IMAGES_ORDERING_REQUEST",
  SAVE_IMAGES_ORDERING_DONE: "SAVE_IMAGES_ORDERING_DONE"
};

export const dashboardActionTypes = {
  SET_CHANGELOG_FILTER: "SET_CHANGELOG_FILTER",
  SET_CHANGELOG_SORT: "SET_CHANGELOG_SORT",
  SET_BOOKMARKS: 'SET_BOOKMARKS',
  ADD_BOOKMARK: 'ADD_BOOKMARK',
  DELETE_BOOKMARK: 'DELETE_BOOKMARK',
  OPEN_DIALOG: 'OPEN_DIALOG',
  CLOSE_DIALOG: 'CLOSE_DIALOG'
};

export const changelogFiltersTypes = {
  FILTER_SHOW_ALL: 'FILTER_SHOW_ALL',
  FILTER_BY_PERMISSIONS: 'FILTER_BY_PERMISSIONS',
  FILTER_BY_TYPE: 'FILTER_BY_TYPE'
};

export const changelogSortTypes = {
  SORT_BY_TIME: 'SORT_BY_TIME',
};

export const bannerActionTypes = {
  GET_BANNER: 'GET_BANNER',
  SET_BANNER_ELEMENT: 'SET_BANNER_ELEMENT',
  DELETE_BANNER_ELEMENT: 'DELETE_BANNER_ELEMENT',
  CHANGE_FILE: 'CHANGE_FILE',
  SET_ELEMENTS_ORDER: 'SET_ELEMENTS_ORDER'
};

export const staticPagesActionTypes = {
  GET_STATIC_PAGES: 'GET_STATIC_PAGES',
  GET_PAGE_TYPES: 'GET_PAGE_TYPES',
  GET_PAGE: 'GET_PAGE'
};

export const categoriesActionTypes = {
  GET_CATEGORIES: 'GET_CATEGORIES',
  CHANGE_FILE: 'CHANGE_FILE'
};

export const couponsActionTypes = {
  IS_REQUEST_PENDING: 'IS_REQUEST_PENDING',
  GET_COUPON: 'GET_COUPON',
  GET_COUPON_OPTIONS: 'GET_COUPON_OPTIONS',
};

export const productFlagsActionTypes = {
  GET_PRODUCT_FLAG: 'GET_PRODUCT_FLAG',
  GET_PRODUCT_FLAG_OPTIONS: 'GET_PRODUCT_FLAG_OPTIONS',
};

export const listActionsActionTypes = {
  GET_ATTRIBUTES: 'GET_ATTRIBUTES'
};

export const instagramActionsTypes = {
  SYNCHRONIZE_POSTS: 'SYNCHRONIZE_POSTS',
  SYNCHRONIZE_POSTS_LOADING: 'SYNCHRONIZE_POSTS_LOADING'
};

export const formActionTypes = {
  HANDLE_OPEN: 'FORM_HANDLE_OPEN',
  HANDLE_CLOSE: 'FORM_HANDLE_CLOSE',
  HANDLE_CHANGE_FORM_DATA: 'FORM_HANDLE_CHANGE_FORM_DATA',
  IS_LOADING: 'FORM_IS_LOADING'
};

export const formIds = {
  SIZE: 'FORM_ID_SIZE'
};

export const forms = {
  [formIds.SIZE]: {
    endpoint: (model) => `/products/${model.product_id}/size/${model.id}`
  }
};

export const changesHistoryActionTypes = {
  GET_CHANGES_HISTORY: "GET_CHANGES_HISTORY",
  SET_NEED_REFRESH: 'SET_NEED_REFRESH',
  GET_OPTIONS: 'GET_OPTIONS',
  IS_REQUEST_PENDING: 'IS_REQUEST_PENDING'
};

export const configurationActionTypes = {
  GET_LIST: 'CONFIGURATION_GET_LIST',
  SAVE: "CONFIGURATION_SAVE"
};

export const eventLogsActionTypes = {
  GET_EVENT_LOGS: 'GET_EVENT_LOGS',
  SET_IS_REQUEST_PENDING: 'SET_IS_REQUEST_PENDING'
};



// WEBPACK FOOTER //
// ./constants/ActionTypes.js